import APP_MAIN_HEADER_TITLE_TYPE from '../types/AppMainHeaderTitleType.js';

const AppMainHeaderTitleReducer= (state = initialState,action)=>{
    switch(action.type){
        case APP_MAIN_HEADER_TITLE_TYPE:
            return Object.assign({}, state, { appMainHeaderTitle: action.data });
        default:
            return state;
    }
};


const initialState = {
    appMainHeaderTitle: ''
};

export default AppMainHeaderTitleReducer;
